import React, { useState, useEffect } from "react"
import classNames from "classnames"
import { useIntl } from "gatsby-plugin-intl"
import * as styles from "./Hero.module.scss"

const Hero = () => {
	const intl = useIntl()
	const [videoLoaded, setVideoLoaded] = useState(false)
	const [isClient, setIsClient] = useState(false)

	useEffect(() => {
		setIsClient(true)
	}, [])

	const heroClass = classNames(styles.hero, "change-header")

	const archives = [
		{ number: "20+", text: "index.intro.archivement.years" },
		{ number: "50+", text: "index.intro.archivement.projects" },
	]

	return (
		<div className={heroClass}>
			<div className={styles.heroBg}></div>

			{isClient && (
				<video
					className={`${styles.heroVideo} ${videoLoaded ? styles.visible : ""}`}
					autoPlay
					muted
					loop
					playsInline
					preload="auto"
					onLoadedData={() => setVideoLoaded(true)}
				>
					<source src="/media/bg-waves.mp4" type="video/mp4" />
				</video>
			)}

			<div className={styles.container}>
				<h1 className={styles.title}>
					{intl.formatMessage({ id: "index.intro.title" })}
				</h1>

				<div className={styles.heroBottom}>
					<ul className={styles.heroList}>
						{archives.map((a, i) => (
							<li key={i}>
								<h3>{a.number}</h3>
								<p>{intl.formatMessage({ id: a.text })}</p>
							</li>
						))}
					</ul>
					<div className={styles.heroAwards}>
						<p>
							Inventale Custom Projects is the 2024 Award-winning company in the
							United Arab Emirates for its Artificial Intelligence, <br />
							Custom Software Development
						</p>
						<div className={styles.heroBanner}>
							<img
								src="/images/hero-awards-banner.png"
								alt="Inventale Custom Projects is the 2024"
								width="134"
								height="40"
							/>
							<img
								src="/images/hero-b-banner.svg"
								alt="Hero awards banner"
								width="23"
								height="24"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Hero
